// ** Initial user ability
export const initialAbility = [
  {
    action: 'read',
    subject: 'overview'
  }
]

export const _ = undefined
